export default {
  SERVER_URL: process.env.VUE_APP_SERVER_URL,
  APP_NAME: "LarLilás",
  MAX_FILE_SIZE: 250000000, // 250 MB, in Bytes
};
